<template>
    <iframe id="iframe" src="https://www.scyxzbcg.cn/webPortal/detail.html?infoId=21633&CatalogId=27" style="height: calc(100%)" width="100%" frameborder="0"></iframe>
<!--    <iframe id="iframe"  style="height: calc(100%)" width="100%" frameborder="0" scrolling="auto"> </iframe>-->
</template>

<script>
    export default {
        name: "common",
        data() {
            return {
                iframeSrc:'https://www.scyxzbcg.cn//trade/drugpurGoods/toUsuallyPriceLinkProductListWebPortal.html'
            }

        },
        created() {
            // let iframe = document.querySelector("#iframe");
            // this.populateIframe(iframe, [["Cookie", "SESSION=40db9645-3ed0-4b2c-b402-2853d0f3b495; queryCondition=6e3adb4ba44c9d6fb90b2afb1b1f9739%3D%7B%22productName%22%3A%22%22%2C%22normalMedicineModel%22%3A%22%22%2C%22normalOutlook%22%3A%22%22%2C%22companyNameSc%22%3A%22%22%2C%22factor%22%3A%22%22%2C%22approvalCode%22%3A%22%22%7D"]])
        },
        methods:{

            // populateIframe(iframe, headers) {
            //     var xhr = new XMLHttpRequest();
            //     xhr.open("GET", 'https://www.scyxzbcg.cn//trade/drugpurGoods/toUsuallyPriceLinkProductListWebPortal.html');
            //     xhr.responseType = "blob";
            //     headers.forEach((header) => {
            //         xhr.setRequestHeader(header[0], header[1]);
            //     });
            //     xhr.onreadystatechange = () => {
            //         if (xhr.readyState === xhr.DONE) {
            //             if (xhr.status === 200) {
            //                 iframe.src = URL.createObjectURL(xhr.response);
            //             }
            //         }
            //     };
            //     xhr.send();
            // },

            getUrl(){
                let url = 'https://www.scyxzbcg.cn//trade/drugpurGoods/toUsuallyPriceLinkProductListWebPortal.html'
                // console.log(url)
                return url;
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/applet/common.vue